export * from './cockpit';
export * from './staticData';
export * from './links';

export const config = {
  googleAnalyticsId: 'ayyy',
};
